
import { useEffect } from "react";

export const useAutoFocus = (
  botIsThinking: boolean,
  setShouldAutoFocus: (shouldAutoFocus: boolean) => void
) => {
  // Ensure input is never blocked by the bot thinking
  useEffect(() => {
    // If the bot is thinking for more than 5 seconds, we'll force focus back to the input
    if (botIsThinking) {
      const timer = setTimeout(() => {
        setShouldAutoFocus(true);
        
        // Find the active input and focus it
        const activeInput = document.querySelector('.Round input:not([disabled])');
        if (activeInput instanceof HTMLElement) {
          activeInput.focus();
        }
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [botIsThinking, setShouldAutoFocus]);
};
